module.exports = __webpack_public_path__ + "img/gys_17@2x.4919bc4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/cooperation/gys_17@2x.png
// module id = QIbf
// module chunks = 0